
import type { SVGProps } from 'react';
const SvgCabineService = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#cabine-service_svg__a)">
      <path
        fill="#263E6A"
        d="M17.629 10.19H13.38a1.245 1.245 0 0 0-.148-1.92A1.248 1.248 0 0 0 12.515 6h-.352a.228.228 0 0 0 0 .456h.352a.794.794 0 0 1 0 1.586H9.568a.794.794 0 0 1 0-1.586h1.365a.228.228 0 0 0 0-.456H9.568a1.248 1.248 0 0 0-.717 2.27 1.248 1.248 0 0 0-.15 1.92H7.068c-.23 0-.443.072-.619.193.012-.566.024-1.226.025-1.628.001-.407-.17-.628-.313-.742-.376-.297-.924-.177-.985-.162a.228.228 0 0 0 .105.444c.108-.026.426-.06.597.077q.141.11.14.382c-.003.661-.034 2.033-.045 2.51l-.001.023v.025l-.003.12q0 .02.003.038v4.796c0 .605.492 1.097 1.096 1.097h.895c.141.704.764 1.237 1.51 1.237.745 0 1.368-.533 1.509-1.237h2.734c.14.704.764 1.237 1.51 1.237.745 0 1.368-.533 1.508-1.237h.895c.605 0 1.097-.492 1.097-1.097v-4.98c0-.604-.492-1.096-1.096-1.096M9.568 8.5h2.947a.794.794 0 0 1 0 1.585H9.568a.794.794 0 0 1 0-1.585m-.096 9.645a1.084 1.084 0 0 1 0-2.167 1.084 1.084 0 0 1 0 2.167m5.752 0a1.084 1.084 0 0 1 0-2.167 1.084 1.084 0 0 1 0 2.167m3.045-1.878a.64.64 0 0 1-.64.64h-.873a1.54 1.54 0 0 0-1.532-1.385c-.797 0-1.454.608-1.532 1.385h-2.689a1.54 1.54 0 0 0-1.531-1.385c-.797 0-1.455.608-1.532 1.385h-.873a.64.64 0 0 1-.64-.64v-1.819h9.574a.228.228 0 0 0 0-.456H6.426v-2.675l.001-.056a.64.64 0 0 1 .64-.613h10.56a.64.64 0 0 1 .64.64zm-8.61-6.974c0-.126.103-.229.229-.229h2.253a.228.228 0 0 1 0 .457H9.888a.23.23 0 0 1-.228-.228m.229-2.27h2.253a.228.228 0 0 1 0 .456H9.888a.228.228 0 0 1 0-.457"
      />
    </g>
    <defs>
      <clipPath id="cabine-service_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCabineService;
